// Template Generated by DataExtraction.py at 1717541024

import CESGEnglish2 from "../../Forms/CESG/CESG_English2.png";
import CESGEnglish2Labels from "../../Labels/CESG/CESG_English2.json";
import CESGFrench2 from "../../Forms/CESG/CESG_French2.png";
import CESGFrench2Labels from "../../Labels/CESG/CESG_French2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrench2Labels : CESGEnglish2Labels;
    const formImage = isFrench ? CESGFrench2 : CESGEnglish2;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const now = moment().format("yyyy/MM/DD");

    // Drawing the form
    // TODO implement fields
    drawText(now, "subscriber1SignDateYyyyMmDd");
    drawText(now, "subscriber2SignDateYyyyMmDd");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrench2Labels : CESGEnglish2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    // subscriber1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("subscriber1Signature", labels))],
    });

    if (state.common.subscriber2Include) {
        // subscriber2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("subscriber2Signature", labels))],
        });
    }


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    